module.exports = __webpack_public_path__ + "static/Truck30-6169d41e3a8b9ed000d753f633a317d6.png";